import React from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const ExclamationMarkIcon = ({ sx, ...otherProps }: SvgIconProps) => (
  <SvgIcon
    viewBox="0 0 24 24"
    sx={{ width: '20px', height: '20px', color: 'secondary.main', ...sx }}
    {...otherProps}
  >
    <path d="M12 11a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1Zm.38-3.92a1 1 0 0 0-.76 0 1 1 0 0 0-.33.21c-.09.1-.16.2-.21.33a1 1 0 0 0 .21 1.09c.1.09.2.16.33.21a1 1 0 0 0 1.09-1.63 1 1 0 0 0-.33-.21ZM12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20Zm0 18a8 8 0 1 1 0-16 8 8 0 0 1 0 16Z" />
  </SvgIcon>
)
